// src/views/Settings/SettingsLayout.jsx
//
// El shell de configuración, montado **una vez** para las tres familias de
// rutas.
//
// Antes cada ruta —usuario, organización, cuenta— renderizaba su propio
// `SettingsShell`. Cambiar de sección desmontaba un componente de ruta y montaba
// otro, así que el shell entero se reconstruía: la barra lateral desaparecía y
// volvía, y su animación de entrada se disparaba de nuevo. Eso era el parpadeo.
//
// Con el shell en una ruta padre, sólo cambia el `<Outlet/>`. La navegación deja
// de reconstruir lo que no cambió, que es casi todo.
import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SettingsShell from './SettingsShell';
import useSettingsGroups from './useSettingsGroups';

export default function SettingsLayout() {
  const groups = useSettingsGroups();
  const location = useLocation();

  return (
    <SettingsShell groups={groups} active={location.pathname}>
      <Outlet />
    </SettingsShell>
  );
}
